<template>
  <div class="mb-2 p-4">
    <validation-observer ref="customActionFormModel" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            :icon="customIcon"
            :title="formTitle"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomDatePicker from "custom-date-picker";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

const ACTIONS = {
  ACCEPT: 0,
  REJECT: 1
};
export default {
  name: "customRequestForm",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomDatePicker
  },
  mixins: [alertMixin],
  props: {
    customIcon: {
      type: String,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    },
    formInfo: {
      type: Object,
      required: true
    },
    action: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      model: {
        comment: ""
      }
    };
  },
  computed: {
    initialDate() {
      return new Date(this.minDate) || new Date();
    }
  },
  mounted() {},
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.customActionFormModel.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      this.$emit("save", this.sendCustomFormData());
    },
    sendCustomFormData() {
      switch (this.action) {
        case ACTIONS.ACCEPT:
          return {
            comment: this.model.comment
          };
        case ACTIONS.REJECT:
          return {
            comment: this.model.comment
          };
        default:
          return {};
      }
    }
  }
};
</script>
